<template>
  <div class="cookie" v-if="isOpen">
    <div class="cookie__content">
      <slot name="message">{{message}}</slot>
    </div>
    <div class="btns">
      <div @click="accept" class="cookie__button accept">{{$t('message.agree')}}</div>
      <div @click="deny" class="cookie_button deny">{{$t('message.refuse')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieMessage",
  props: {
    counter: {
      type: Number,
      default: 0
    },
    buttonTextAccept: {
      type: String,
      default: "J'accepte"
    },
    buttonTextDeny: {
      type: String,
      default: "Je refuse"
    },
    message: {
      type: String,
      default:
        "Ce site utilise des cookies pour améliorer votre expérience utilisateur."
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    if (!this.getGDPR() === true) {
      this.isOpen = true;
    }
  },
  methods: {
    getGDPR() {
      return localStorage.getItem("GDPR:accepted", true);
    },
    accept() {
      this.isOpen = false;
      localStorage.setItem("GDPR:accepted", true);
    },
    deny() {
      this.isOpen = false;
      localStorage.setItem("GDPR:accepted", false);
    }
  }
};
</script>

<style lang="scss">
@import "../../css/variables";
.cookie {
  position: fixed;
  bottom: 0;
  background-color: $primary;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 99999;
  padding: 15px 10px;
  .cookie__content {
    margin: 0 auto;
    padding: 1em;
    color: white;
    flex: 1;
  }
  .btns {
    display: flex;
    .accept {
      background-color: white;
      border: 1;
      border-radius: 15px;
      color: $primary;
      padding: 1em;
      margin: 0 10px;
      cursor: pointer;
      &:hover {
        background-color: #edefed;
      }
    }
    .deny {
      padding: 1em;
      color: #fff;
      margin: 0 10px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

@media screen and (max-width:800px) {
  .cookie {
    flex-direction: column;
  }
}
/*@media screen and (min-width: $tablet) {
  .cookie {
    position: fixed;
    bottom: 0;
    background-color: $primary;
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 70px;
    justify-content: space-evenly;
    align-items: center;
    .cookie__content {
      width: 100%;
    }
    .btns {
      .accept,
      .deny {
        background-color: white;
        border: 1;
        border-radius: 15px;
        color: $primary;
        padding: 1em;
        box-shadow: 2px 2px 12px 5px rgba(114, 108, 108, 0.2);
        &:hover {
          background-color: $primary;
          color: white;
          box-shadow: 2px 2px 12px 5px rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
}*/
</style>
